import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import { Form, Field } from 'react-final-form';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import TextFieldAdapter from 'components/shared/TextFieldAdapter';
import DialogLoadingIndicator from 'components/shared/DialogLoadingIndicator';
import SectionTitle from 'components/layout/SectionTitle';
import { constructionActions } from 'store/modules/construction';
import { uiActions } from 'store/modules/ui';
import { constructionStatus } from 'common/constants';
import routes from 'common/routes';
import { validateConstruction } from 'common/formValidations';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(3),
  },
  submit: {
    textAlign: 'right',
  },
  cancel: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      marginRight: 0,
    },
  },
}));

const initialValues = {
  name: '',
  work_order: '',
  status: constructionStatus.active,
};

const CreateConstruction = () => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const { loading } = useSelector((state) => ({ loading: state.construction.loading.list }));

  useEffect(() => {
    dispatch(uiActions.updatePageTitle(routes.construction.create.title));
  }, [dispatch]);

  const resetAll = (args) => {
    const form = args[0];

    form.restart();
  };

  const onSubmit = (values) => {
    dispatch(constructionActions.createConstruction(values));
  };

  return (
    <React.Fragment>
      <SectionTitle text="Crear Obra" backButton />
      <Paper square className={classes.paper}>
        <Form
          initialValues={initialValues}
          validate={validateConstruction}
          onSubmit={onSubmit}
          mutators={{
            resetAll,
          }}
          render={({
            handleSubmit,
            invalid,
            pristine,
            form,
          }) => (
            <form onSubmit={handleSubmit}>
              <DialogLoadingIndicator open={loading} />
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Field
                    id="name-create"
                    name="name"
                    component={TextFieldAdapter}
                    label="Nombre"
                    required
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    id="work_order-create"
                    name="work_order"
                    component={TextFieldAdapter}
                    label="OT"
                    required
                    fullWidth
                  />
                </Grid>
                <Grid item xs={4} sm={6}>
                  <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      form.mutators.resetAll(form);
                    }}
                  >
                    Reiniciar
                  </Button>
                </Grid>
                <Grid item xs={8} sm={6} className={classes.submit}>
                  <Button
                    className={classes.cancel}
                    type="button"
                    color="secondary"
                    component={RouterLink}
                    to={routes.construction.index.path}
                  >
                    Cancelar
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={invalid || pristine || loading}
                  >
                    Crear
                  </Button>
                </Grid>
              </Grid>
            </form>
          )}
        />
      </Paper>
    </React.Fragment>
  );
};

export default CreateConstruction;
